import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门游戏分类</h2>
          <p className="text-foreground-600 text-sm md:text-base">八大游戏品类，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">{cat.name}</h3>
              <p className="text-foreground-500 text-xs">{cat.gameCount}款游戏</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}